var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "780px",
      "max-width": "80%"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "px-0",
          attrs: {
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-chip', _vm._b({
          staticClass: "mr-2",
          attrs: {
            "color": "primary"
          },
          model: {
            value: _vm.request.area,
            callback: function callback($$v) {
              _vm.$set(_vm.request, "area", $$v);
            },
            expression: "request.area"
          }
        }, 'v-chip', _vm.chipProps, false), [_vm._v(" " + _vm._s(_vm.request.area.parent.name) + " /" + _vm._s(_vm.request.area.name) + " ")]), _vm._v(" 외 " + _vm._s(_vm.areas.length - 1) + " 개 ")], 1)];
      }
    }]),
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-col', [_c('v-chip-group', {
    attrs: {
      "value": _vm.request._area,
      "column": "",
      "color": "primary"
    }
  }, _vm._l(_vm.areas, function (area) {
    return _c('v-chip', _vm._b({
      key: area._id,
      staticStyle: {
        "opacity": "1"
      },
      attrs: {
        "value": area._id,
        "disabled": ""
      }
    }, 'v-chip', _vm.chipProps, false), [_vm._v(_vm._s(area.parent.name) + " /" + _vm._s(area.name))]);
  }), 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }